module.exports = __webpack_public_path__ + "fonts/deposit-guide-2.47ed5b24s.png";